import React from 'react';
import { CardGroup, ContentCard, Paper } from 'library';
import { take } from 'lodash';
import { formatDate } from 'utils/formatters';
import { filterCategoriesByName } from 'utils/wpUtilities';

import { mapBlogToComponent } from '../../blocks/CardGroupBlock/cardGroupBlockUtils';
import CategoryNav from '../../common/CategoryNav/CategoryNav';
import LoadMore from '../../common/Pagination/LoadMore';
import usePagination from '../../common/Pagination/UsePagination';
import Layout from '../../layout';
import BlogSubscription from '../BlogSubscription/BlogSubscription';
import FeaturedPostCard from '../FeaturedPostCard/FeaturedPostCard';
import ResourcesCTA from '../ResourcesCTA/ResourcesCTA';

import './BlogFeed.scss';

const BlogFeed = ({ data }) => {
  const { post, category } = data;
  const categories = category.edges;
  const postCategories = post.nodes;
  const featuredPost = postCategories.find((post) => post.blogFields.isFeatured);
  const featuredPostCardData = mapBlogToComponent(featuredPost);
  const sortedPosts = postCategories
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .filter((post) => !post.blogFields.hideFromBlogFeed && post !== featuredPost);
  const latestPosts = sortedPosts.slice(0, 6);
  const morePosts = sortedPosts.slice(6);
  const { hasMoreToLoad, countVisible, handleLoadMore } = usePagination({
    total: morePosts?.length,
    initialPageCount: 6,
    incrementLimit: 6,
  });

  return (
    <Layout>
      <BlogSubscription />
      <Paper theme="medium" divider>
        <CategoryNav activeSlug="blog" categories={filterCategoriesByName('blog', categories)} />
        {featuredPostCardData && (
          <FeaturedPostCard
            image={featuredPostCardData?.image}
            altText={featuredPostCardData?.alt}
            title={featuredPostCardData?.title}
            link={featuredPostCardData?.link}
            text={featuredPost.blogFields?.featuredCardText}
            author={featuredPost.blogFields?.authorName}
            date={formatDate(featuredPost.date)}
          />
        )}
        <div className="BlogFeedLastestWrapper">
          <CardGroup cardSize={ContentCard.size} title="Latest Articles" preventOrphans>
            {latestPosts.map((item, index) => {
              return <ContentCard {...mapBlogToComponent(item)} key={index} />;
            })}
          </CardGroup>
        </div>
        <ResourcesCTA />
        <div className="BlogFeedMoreWrapper">
          <CardGroup cardSize={ContentCard.size} title="More Articles">
            {take(morePosts, countVisible).map((item, index) => {
              return <ContentCard {...mapBlogToComponent(item)} key={index} />;
            })}
          </CardGroup>
          {hasMoreToLoad && <LoadMore onClick={handleLoadMore} />}
        </div>
      </Paper>
    </Layout>
  );
};

export default BlogFeed;
